// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';

import './ScopeButton.scss';

interface ScopeButtonProps {
    label: string;
    active: boolean;
    icon: ReactElement;
    onClick: () => void;
}

const ScopeButton = ({ label, icon, active, onClick }: ScopeButtonProps): ReactElement => {
    return (
        <div
            className={classList('scope-button', { 'scope-button__selected': active })}
            role="button"
            onClick={onClick}
        >
            <span className="scope-button__label">{label}</span>
            {icon}
        </div>
    );
};

export default ScopeButton;
